import { render, staticRenderFns } from "./template.vue?vue&type=template&id=dafcfd6a&scoped=true&"
import script from "./template.vue?vue&type=script&lang=js&"
export * from "./template.vue?vue&type=script&lang=js&"
import style0 from "./template.vue?vue&type=style&index=0&lang=css&"
import style1 from "./template.vue?vue&type=style&index=1&id=dafcfd6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafcfd6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dafcfd6a')) {
      api.createRecord('dafcfd6a', component.options)
    } else {
      api.reload('dafcfd6a', component.options)
    }
    module.hot.accept("./template.vue?vue&type=template&id=dafcfd6a&scoped=true&", function () {
      api.rerender('dafcfd6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/template.vue"
export default component.exports